module.exports = "<div>\n  <storm-tickets-table v-if=\"$router.currentRoute.path === '/storm-tickets'\" @set-ticket=\"setActiveTicket\" />\n  <router-view :active-ticket=\"activeTicket\"></router-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/storm/pages/tickets/template.html
// module id = vgAY
// module chunks = 0